import {WriteButton} from '../../common/buttons/WriteActions';
import {Alert, Button, Container, Skeleton, Stack} from '@mui/material';
import {ArrowBackIosNew} from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {decorationAPI} from '../../../services/DecorationService';
import {itemAPI} from '../../../services/ItemServices';
import {SaveDecorationGuidRequest} from '../../../models/Decorations/IDecorationGuid';
import DecorationForm from './DecorationForm';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {getApiErrorMessage} from '../../../common/apiErrors';
import {useState} from 'react';
import {DeleteDecorationDialog} from './DeleteDecorationDialog';

export const DecorationEditPage = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const {t} = useAppTranslation();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteError, setDeleteError] = useState('');
    const {
        data: decoration,
        error: decorationError,
        isLoading: decorationLoading,
        isSuccess: decorationSuccess,
        refetch: refetchDecoration,
    } = decorationAPI.useGetDecorationV2Query(id || '');
    const {data: items, error: itemsError, isLoading: itemsLoading, isSuccess: itemsSuccess, refetch: refetchItems} = itemAPI.useGetAllItemsV2LightQuery();
    const [updateDecoration] = decorationAPI.useUpdateDecorationV2Mutation();
    const [deleteDecoration] = decorationAPI.useDeleteDecorationV2Mutation();
    const ready = decorationSuccess && !!decoration && itemsSuccess;
    const handleSubmit = async (value: SaveDecorationGuidRequest) => {
        const editedId = decoration?.id ?? id ?? '';
        const returnPage = (location.state as { returnPage?: number } | null)?.returnPage;
        await updateDecoration({id: editedId, body: {...value, id: editedId}}).unwrap();
        navigate('/app/recipes/decorations', {state: {expandedId: editedId, page: returnPage}});
    };
    const handleDelete = async () => {
        if (!decoration) return false;
        setDeleteError('');
        try {
            await deleteDecoration(decoration.id ?? id ?? '').unwrap();
            navigate('/app/recipes/decorations');
            return true;
        } catch (error) {
            setDeleteError(getApiErrorMessage(error, t));
            return false;
        }
    };
    return <Container maxWidth="xl" sx={{py: 3}}><Button variant="outlined" startIcon={<ArrowBackIosNew/>}
                                                         onClick={() => navigate('/app/recipes/decorations')}>{t('recipes:back_to_decorations')}</Button>{(decorationLoading || itemsLoading) &&
        <Stack spacing={2} sx={{mt: 2}}><Skeleton variant="rounded" height={120}/><Skeleton variant="rounded"
                                                                                            height={260}/><Skeleton
            variant="rounded" height={200}/></Stack>}{(decorationError || itemsError) && <Alert severity="error" sx={{mt: 2}} action={<Button color="inherit" onClick={() => { refetchDecoration(); refetchItems(); }}>{t('settings:retry')}</Button>}>{getApiErrorMessage(decorationError || itemsError, t)}</Alert>}{ready &&
        <><DecorationForm availableItems={items} initialData={decoration}
                        changeMode={() => navigate('/app/recipes/decorations')} onSubmit={handleSubmit}/><WriteButton sx={{mt: 2}} color="error" variant="outlined" startIcon={<DeleteIcon/>} onClick={() => setDeleteOpen(true)}>{t('recipes:delete_decoration')}</WriteButton>
            <DeleteDecorationDialog open={deleteOpen} onClose={() => setDeleteOpen(false)} decorationName={decoration.name} onDelete={handleDelete} error={deleteError}/></>}</Container>;
};
